import { ShortcutData } from 'components/KeyboardShortcutsTooltip';

export const BOM_BUILDER_KEYBOARD_SHORTCUTS: ShortcutData[] = [
  {
    labelContent: (
      <>
        Ctrl + C (Windows)
        <br />⌘ + C (Mac)
      </>
    ),
    definitionContent: 'Copy',
  },
  {
    labelContent: (
      <>
        Ctrl + V (Windows)
        <br />⌘ + V (Mac)
      </>
    ),
    definitionContent: 'Paste',
  },
  {
    labelContent: (
      <>
        Ctrl + Z (Windows)
        <br />⌘ + Z (Mac)
      </>
    ),
    definitionContent: 'Undo',
  },
  {
    labelContent: (
      <>
        Ctrl + Y (Windows)
        <br />⌘ + Shift + Z (Mac)
      </>
    ),
    definitionContent: 'Redo',
  },
  {
    labelContent: 'Delete or Backspace',
    definitionContent:
      'Delete selected row(s) or delete selected cell(s) content',
  },
  {
    labelContent: 'Arrow keys',
    definitionContent: 'Move cell focus to neighboring cell',
  },
  {
    labelContent: 'Shift + Arrow keys',
    definitionContent: 'Add neighboring cell to selection',
  },
  {
    labelContent: 'Enter',
    definitionContent: 'Edit cell or move focus down',
  },
  {
    labelContent: 'Tab',
    definitionContent: 'Move focus to right',
  },
  {
    labelContent: 'Shift + Tab',
    definitionContent: 'Move focus to left',
  },
  {
    labelContent: 'Home/End',
    definitionContent: 'Scroll to top/bottom',
  },
  {
    labelContent: 'PageUp/PageDown',
    definitionContent: 'Scroll up/down',
  },
  {
    labelContent: 'Escape',
    definitionContent: 'Cancel cell editing',
  },
  {
    labelContent: (
      <>
        Ctrl + A (Windows)
        <br />⌘ + A (Mac)
      </>
    ),
    definitionContent: 'Select all cells',
  },
];
